import React, { useState } from "react";
import Modal from "../../../../../components/modal";
import Button from "../../../../../components/new-button";
import styles from "./styles.module.scss";
import toast from "react-hot-toast";
import useEquipmentStore, {
  fetchCategories,
} from "../../../../../stores/equipment";
import { deleteEquipmentCategory } from "../../../../../../api";

const DeleteCategoryModal = ({ open, onClose }) => {
  const [submitting, setSubmitting] = useState(false);
  const activeCategory = useEquipmentStore((state) => state.activeCategory);

  const remove = async () => {
    setSubmitting(true);

    try {
      toast.loading("Deleting equipment category...");

      const response = await deleteEquipmentCategory(activeCategory.id);
      toast.dismiss();

      if (!response?.status) {
        toast.error(
          response?.message ||
            "There was a problem deleting the equipment category",
        );
        console.error(response);
        onClose();
        return;
      }

      toast.success("Equipment category deleted successfully");
      fetchCategories();
      onClose();
    } catch (error) {
      toast.error("There was a problem deleting the equipment category");
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      header="Are you sure want to remove this equipment category? You cannot undo this action."
      headingCenteredSpaced
      isOpen={open}
      onClose={onClose}
    >
      <div className={styles.actionWrapper}>
        <Button variant="ghost" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={remove} disabled={submitting}>
          Delete
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteCategoryModal;
